export default __webpack_public_path__ + "static/media/website-19 1.74c78eff.jpg";